module.exports = __webpack_public_path__ + "img/Ergonomist-Marci-Baptista-m.d7177aeb.png";